import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const VideoSection = ({ title, description, videoUrl }) => {
  return (
    <Box sx={{ py: 8, backgroundColor: '#000' }}>
      <Container maxWidth="md" sx={{ textAlign: 'center', color: '#fff' }}>
        {title && (
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="body1" color="gray" mb={4}>
            {description}
          </Typography>
        )}
        <Box
          sx={{
            position: 'relative',
            paddingTop: '56.25%', // 16:9 aspect ratio
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 3,
          }}
        >
          <iframe
            src={videoUrl}
            title="CardexMedico Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            frameBorder="0"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 0,
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default VideoSection;
